exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".show-detail.ui.button {\n  float: right;\n  font-size: 12px;\n  padding: 5px;\n}\n.producer-logo-container img {\n  height: 20px;\n}\n.producer-logo-container {\n  float: left;\n  width: 25px;\n}\n.table-cell {\n  overflow: hidden;\n  float: left;\n  width: 100px;\n  margin-left: 10px;\n  font-size: 12px;\n}\n", ""]);

// exports
